export default {
  data() {
    return {
      interval: null
    }
  },
  methods: {
    tick: undefined,
    start() {
      this.tick()
      this.interval = setInterval(this.tick.bind(this), 1000)
    },
    stop() {
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.interval = null
    }
  },
  mounted() {
    this.start()
  },
  beforeDestroy() {
    this.stop()
  }
}
